import { environment } from '@env/environment';
import { MenuItem } from '../models/menu/menu.model';
import { menuItems } from './default-menu';


export function getMenu(): MenuItem[] {
  const menuSetting = environment.clientAccount.menu;
  let menu: MenuItem[];
  switch (menuSetting) {
    default: {
      menu = constructedMenu(menuItems);
      break;
    }
  }
  return menu;
}

function constructedMenu(customMenu) {
  const fullMenu = [];
  menuItems.forEach((m) => {
    const customMenuItem = customMenu.find(
      (f: { routeIdentifier: string }) =>
        f.routeIdentifier === m.routeIdentifier,
    );
    const menuItem = Object.assign({}, m, customMenuItem);
    if (customMenuItem && customMenuItem.subMenu) {
      menuItem.subMenu = [];
      m.subMenu.forEach((sm) => {
        const cmi = customMenuItem.subMenu.find(
          (mis) => mis.routeIdentifier === sm.routeIdentifier,
        );
        const smi = Object.assign({}, sm, cmi);
        menuItem.subMenu.push(smi);
      });
    }

    fullMenu.push(menuItem);
  });
  return fullMenu;
}
